import { useLocaleStore } from 'store/context'

export const useCurrency = () => {
  const localeStore = useLocaleStore()
  return localeStore.currency
}
